export const internshipData = [
  
  {
    id: 1,
    company: "Iserveu Technology(Internship)",
    jobtitle: "Software Developer",
    startYear: "April 2020",
    endYear: "July 2020",
  },
  {
    id: 2,
    company: "Codekart Technology(Internship)",
    jobtitle: "Web Developer",
    startYear: "June 2019",
    endYear: "August 2019",
  },
  {
    id: 3,
    company: "Appstone Pvt Ltd",
    jobtitle: "Web Developer(Internship)",
    startYear: "January 2019",
    endYear: "April 2019",
  },
  
  {
    id: 4,
    company: "Syon India Advance Solution",
    jobtitle: "Node Js Developer(Internship)",
    startYear: "May 2018",
    endYear: "July 2018",
  },  
];
